import React, { useState, useEffect } from 'react';
import BootSequence from './components/terminal/BootSequence';
import Terminal from './components/terminal/Terminal';
import ScanLines from './components/effects/ScanLines';

const App: React.FC = () => {
  const [bootComplete, setBootComplete] = useState(false);

  const handleBootComplete = () => {
    console.log('Boot sequence completed, showing terminal');
    setBootComplete(true);
  };

  useEffect(() => {
    console.log('App component mounted, bootComplete:', bootComplete);
  }, [bootComplete]);

  // Add a fallback to show terminal after a reasonable timeout
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!bootComplete) {
        console.log('Boot timeout reached, forcing terminal display');
        setBootComplete(true);
      }
    }, 10000); // 10 second timeout

    return () => clearTimeout(timeout);
  }, [bootComplete]);

  return (
    <div style={{ height: '100vh', width: '100vw', overflow: 'hidden', backgroundColor: '#0a0a0a' }}>
      {!bootComplete ? (
        <BootSequence onComplete={handleBootComplete} />
      ) : (
        <div style={{ height: '100%', width: '100%', position: 'relative' }}>
          <Terminal />
          <ScanLines />
        </div>
      )}
    </div>
  );
};

export default App;
